import SectionTitle from "./common/SectionTitle";
import { useInView } from "../hooks/useInView";

export default function About() {
  const [aboutRef, aboutVis] = useInView();

  const educationData = [
    {
      year: "2024 – Present",
      degree: "Consultant Nephrologist",
      inst: "Ashtamangal Surgical & Invictus Gastro Hospitals, Ahmedabad",
    },
    {
      year: "2021 – 2024",
      degree: "DM Nephrology",
      inst: "B.J. Medical College / Civil Hospital, Ahmedabad",
    },
    {
      year: "2018 – 2021",
      degree: "MD Internal Medicine",
      inst: "Gujarat Medical University, Ahmedabad",
    },
    {
      year: "2012 – 2018",
      degree: "MBBS",
      inst: "Gujarat Medical University",
    },
  ];

  const qualifications = [
    { label: "Qualification", value: "MD, DM (Nephrology)" },
    { label: "Specialty", value: "Nephrology & Kidney Transplant" },
    { label: "Languages", value: "Gujarati, Hindi, English" },
    { label: "Locations", value: "Shahibaug & Nikol, Ahmedabad" },
  ];

  return (
    <div id="about" style={{ padding: "80px 20px", background: "white" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <SectionTitle
          tag="About the Doctor"
          title="Meet Dr. Gaurav B. Modi"
          sub="A decade of dedication to kidney health and transplant medicine"
        />

        <div
          ref={aboutRef}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 60,
            alignItems: "start",
            opacity: aboutVis ? 1 : 0,
            transform: aboutVis ? "translateY(0)" : "translateY(30px)",
            transition: "all 0.7s ease",
          }}
        >
          <div>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.8,
                marginBottom: 18,
                fontSize: 15,
              }}
            >
              Dr. Gaurav B. Modi is a distinguished Consultant Nephrologist and
              Kidney Transplant Physician practising across two premier hospitals
              in Ahmedabad. With over 10 years of specialised experience, he
              brings deep expertise in managing the entire spectrum of kidney
              disorders.
            </p>
            <p
              style={{
                color: "#475569",
                lineHeight: 1.8,
                marginBottom: 30,
                fontSize: 15,
              }}
            >
              From early-stage chronic kidney disease to complex transplant
              procedures, Dr. Modi's holistic approach combines cutting-edge
              diagnostics with compassionate, patient-centred care — empowering
              patients to take charge of their kidney health journey.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 14,
                marginBottom: 28,
              }}
            >
              {qualifications.map((item, i) => (
                <div
                  key={i}
                  style={{
                    background: "#f8fafc",
                    borderRadius: 14,
                    padding: "14px 16px",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <div
                    style={{
                      fontSize: 11,
                      color: "#0d9488",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      marginBottom: 4,
                    }}
                  >
                    {item.label}
                  </div>
                  <div
                    style={{
                      fontSize: 13,
                      color: "#1e293b",
                      fontWeight: 600,
                    }}
                  >
                    {item.value}
                  </div>
                </div>
              ))}
            </div>

            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              {[
                { label: "📘 Facebook", url: "https://www.facebook.com/share/1BycZS3A1v/" },
                { label: "📸 Instagram", url: "https://www.instagram.com/gauravmodi912?igsh=MTFxMXN5dmt0OGsxNw==" },
                { label: "💼 LinkedIn", url: "https://www.linkedin.com/in/prakashmodi11191/" }
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    fontSize: 13,
                    background: "#eff6ff",
                    color: "#1d4ed8",
                    padding: "6px 14px",
                    borderRadius: 50,
                    fontWeight: 600,
                    cursor: "pointer",
                    textDecoration: "none",
                    transition: "background 0.2s, color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = "#dbeafe";
                    (e.currentTarget as HTMLAnchorElement).style.color = "#0d4ed8";
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.background = "#eff6ff";
                    (e.currentTarget as HTMLAnchorElement).style.color = "#1d4ed8";
                  }}
                >
                  {social.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3
              style={{
                fontWeight: 700,
                fontSize: 17,
                marginBottom: 20,
                color: "#1e293b",
              }}
            >
              Education & Training
            </h3>
            {educationData.map((item, i, arr) => (
              <div key={i} style={{ display: "flex", gap: 16 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 14,
                      height: 14,
                      borderRadius: "50%",
                      background: "#0d9488",
                      border: "3px solid #ccfbf1",
                      marginTop: 4,
                      flexShrink: 0,
                    }}
                  />
                  {i < arr.length - 1 && (
                    <div
                      style={{
                        width: 2,
                        flex: 1,
                        background: "#e2e8f0",
                        margin: "4px 0",
                      }}
                    />
                  )}
                </div>
                <div style={{ paddingBottom: 22 }}>
                  <div
                    style={{
                      fontSize: 12,
                      color: "#0d9488",
                      fontWeight: 700,
                      marginBottom: 2,
                    }}
                  >
                    {item.year}
                  </div>
                  <div style={{ fontWeight: 700, color: "#1e293b", fontSize: 14 }}>
                    {item.degree}
                  </div>
                  <div style={{ color: "#64748b", fontSize: 13 }}>
                    {item.inst}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
